<template>
    <FilterExpandCollapse
      label="Medical Equipment"
      :expand="false"
      v-if="show"
    >
      <!-- Need to put a key on the ShowMore component so that it will redraw completely when the data changes -->
      <!-- If we don't do this we will get DOM errors when the slot gets re-rendered                           -->
      <FilterShowMore :threshold="10" :topLength="3" :key="showMoreKey">
        <div v-for="equipment in medicalEquipment" :key="equipment.id">
          <hp5-semantic size-selection="xs">
            <input :id="`equipment-${equipment.id}`" type="checkbox" v-model="filterContext.cc" :value="equipment.id" />
            <label :for="`equipment-${equipment.id}`">{{ equipment.name }}</label
            >
          </hp5-semantic>
        </div>
      </FilterShowMore>
    </FilterExpandCollapse>
</template>
  
<script setup>

    const model = useFCPModel()
    const { filterContext, rawConcepts } = model
    const cc = computed(() => filterContext.value.cc)
    const term = computed(() => filterContext.value.term)
    const isMedicalOrDental = computed(() => filterContext.value.type == 'medical' || filterContext.value.type == 'dental')
    const show = computed(() => isMedicalOrDental.value && (medicalEquipment.value && medicalEquipment.value.length > 0))
    const showMoreKey = computed(() => JSON.stringify(medicalEquipment.value))
    const type = computed(() => filterContext.value.type)

    const medicalEquipment = computed(() => {
        return rawConcepts.value.filter(concept => concept.type == 'medicalequipment')
    })
  
  </script>
  
<style scoped>
  label {
    padding-left: var(--spacing-xs);
  }
</style>